<template>
  <div>
    <div class="container">

      <div class="columns mt-01">

        <div class="column">

          <h4 class="title is-4">¿Qué es La CROC? </h4>
          <p class="has-text-justified">La CROC somos una organización comprometida, disciplinada y encaminada a conseguir el desarrollo social integral de las familias; un sindicato generador de empleo y productividad que, de acuerdo a la combinación de acciones y resultados, hemos logrado la confianza de los trabajadores y las empresas, permitiendo con ello aumentar el número de afiliados y transformar el sindicalismo tradicional al Sindicalismo Social del Siglo XXI.</p>
          <h4 class="title is-4 mt-05"> Mision </h4>
          <p class="has-text-justified"> Defender los derechos humanos y constitucionales de los trabajadores y sus familias, buscando siempre mejorar sus intereses económicos, sociales y culturales.</p>
          <h4 class="title is-4 mt-05"> Vision </h4>
          <p class="has-text-justified">Ser una Organización profesional y de vanguardia, útil por su contribución a la justicia social y al desarrollo económico del país. </p>
          <h4 class="title is-4 mt-05">Valores </h4>
          <p>• Unidad. </p>
          <p>• Solidaridad. </p>
          <p>• Honestidad en la Gestión Sindical.</p>
          <p>• Lealtad al Trabajo. </p>
          <p>• La Familia </p>
          <h4 class="title is-4 mt-05"> Sindicalismo Social del Siglo XXI </h4>
          <p class="has-text-justified">La CROC ha transformado el sindicalismo tradicional que se ocupaba solamente de buscar y mantener el equilibrio obrero patronal dentro de las empresas, a un Sindicalismo Social del Siglo XXI, el cual tiene como fundamento principal extender los servicios y atender los problemas del trabajador y su familia, partiendo de la tesis “todo asunto que sea del trabajador, lo es también de la Organización y, por tanto, se han realizado programas, emprendido acciones y brindado resultados”.
    Por ello se han implementado varios programas de gran impacto en el lugar donde viven y conviven socialmente </p>
          <h4 class="title is-4 mt-05"> Programas Sociales </h4>
          <p class="has-text-justified">Gracias a la visión vanguardista del Secretario General del C.E.N. de la CROC, C. Isaías González Cuevas, Senador de la República por el Estado de Baja California Sur, se transformó el sindicalismo tradicional que se ocupaba únicamente de buscar y mantener el equilibrio obrero patronal dentro de las empresas a un Sindicalismo Social del Siglo XX, partiendo de la tesis “Todo asunto que sea del trabajador, lo es también de la Organización”, de modo que se han emprendido Acciones Nacionales de gran impact</p>

        </div>


      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Croc',
  data () {
    return {

    }
  },
  computed: {
  },
  components: {

  },
  mounted() {

  },
  methods:{

  },
  created :function(){

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Croc.vue